import { Chip, Tooltip } from '@mui/material';

const VARIANTS = {
  order: { label: 'Юрлицо', title: 'Заказ от юрлица (B2B) — отдельная поставка' },
  supply: { label: 'Юрлица', title: 'Поставка для заказов юрлиц (B2B) — обычные заказы сюда нельзя' },
  pallet: { label: 'Юрлица', title: 'Палета для заказов юрлиц (B2B) — обычные заказы сюда нельзя' },
};

/**
 * Пометка WB-заказа/поставки/палеты от юрлица (B2B).
 * kind: order | supply | pallet. Рисуется только при show=true.
 */
export default function B2bChip({ show = true, kind = 'order', size = 'small', sx }) {
  if (!show) return null;
  const variant = VARIANTS[kind] || VARIANTS.order;
  return (
    <Tooltip title={variant.title} arrow>
      <Chip
        size={size}
        color="secondary"
        variant="filled"
        label={variant.label}
        sx={{ fontWeight: 700, ...sx }}
      />
    </Tooltip>
  );
}
